import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { connect } from "react-redux";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const Organisation = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const dispatch = useDispatch();
  const [inputData, setInputData] = useState([]);
  const [primaryOrganisation, setPrimaryOrganisation] = useState([]);
  const [secondaryOrgansation, setSecondaryOrganisation] = useState([]);

  const [isEnable, setIsEnable] = useState({
    save: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    if (
      eventName === "primary_organisation" ||
      eventName === "secondary_organisation"
    ) {
      if (eventName === "primary_organisation") {
        setPrimaryOrganisation(event);
      } else {
        setSecondaryOrganisation(event);
      }
      if (event != null) {
        setInputData((prevState) => ({
          ...prevState,
          [eventName]: event["id"],
        }));
      } else {
        setInputData((prevState) => ({ ...prevState, [eventName]: null }));
      }
    } else {
      setInputData((prevState) => ({
        ...prevState,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateOrganisation = {
      userId: inputData.userId,
      primary_organisation: inputData.primary_organisation,
      primary_organisation_experience:
        inputData.primary_organisation_experience,
      secondary_organisation: inputData.secondary_organisation,
      secondary_organisation_experience:
        inputData.secondary_organisation_experience,
    };
    dispatch(updateProfleAction(inputData.userId, updateOrganisation));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const organisation = {
        userId: props.profile.userId,
        primary_organisation: props.profile.primary_organisation,
        primary_organisation_experience:
          props.profile.primary_organisation_experience,
        secondary_organisation: props.profile.secondary_organisation,
        secondary_organisation_experience:
          props.profile.secondary_organisation_experience,
      };
      setInputData(organisation);
    }

    if (props.organisations) {
      if (inputData.primary_organisation != null) {
        const primaryOrgnisationData = props.organisations.find(
          (row) => row.id === inputData.primary_organisation
        );
        if (props.primarySectorId != null) {
          setPrimaryOrganisation(primaryOrgnisationData);
        } else {
          setPrimaryOrganisation(null);
        }
      }
      if (inputData.secondary_organisation != null) {
        const secondaryOrganisationData = props.organisations.find(
          (row) => row.id === inputData.secondary_organisation
        );
        if (props.secondarySectorId != null) {
          setSecondaryOrganisation(secondaryOrganisationData);
        } else {
          setSecondaryOrganisation(null);
        }
      }
    }
  }, [props]);
  return (
    <div className="row margin-row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Organisation"}
      />
      <div className="col-12">
        <div className="timeline-border-box">
          <h5>Organisation</h5>
          <div className="row">
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">Primary Organisation</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="primary_organisation"
                    name="primary_organisation"
                    value={
                      props.organisations &&
                      props.organisations.find(
                        (organisation) =>
                          organisation.id === inputData.primary_organisation
                      )
                    }
                    options={props.organisations}
                    getOptionLabel={(option) => option.organisation}
                    getOptionValue={(option) => option.id}
                    onChange={(event) =>
                      handleChange(event, "primary_organisation")
                    }
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                    isDisabled={props.primarySectorId === null ? true : false}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">Years Of Experience</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <input
                    type="number"
                    className="form-control"
                    name="primary_organisation_experience"
                    min="0"
                    placeholder="Primary Organisation Years Of Experience"
                    onChange={(event) => handleChange(event)}
                    defaultValue={inputData.primary_organisation_experience}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <label className="field-label">Secondary Organisation</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <Select
                    id="secondaryOrganisation"
                    name="secondary_organisation"
                    options={props.organisations}
                    value={
                      props.organisations &&
                      props.organisations.find(
                        (organisation) =>
                          organisation.id === inputData.secondary_organisation
                      )
                    }
                    getOptionLabel={(option) => option.organisation}
                    getOptionValue={(option) => option.id}
                    onChange={(event) =>
                      handleChange(event, "secondary_organisation")
                    }
                    placeholder="Choose.."
                    isClearable={true}
                    styles={customStyles}
                    isDisabled={
                      primaryOrganisation === null ||
                      props.secondarySectorId === null
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <label className="field-label">Years Of Experience</label>
              <div className="expertise-fields">
                <div className="single-field mb-3">
                  <input
                    type="number"
                    className="form-control"
                    name="secondary_organisation_experience"
                    min="0"
                    placeholder="Secondary Organisation Years Of Experience"
                    onChange={(event) => handleChange(event)}
                    defaultValue={
                      inputData.secondary_organisation != null
                        ? inputData.secondary_organisation_experience
                        : null
                    }
                  />
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const organisations = state.admin.organisations;

  return {
    user: user,
    profile: profile,
    organisations: organisations,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Organisation);
